/**
 * @ignore
 */
const g2=require('../../../g2');
const DrawPointTool = require('./DrawPointTool');
const DrawLineTool = require('./DrawLineTool');
const DrawPolygonTool = require('./DrawPolygonTool');
const Tool = g2.interact.Tool.extend({
    initialize: function (opt) {
        var opts = opt || {};
        g2.interact.Tool.call(this, opts);
        //
        this.map = opt.map;
        //
        this.toolCol={};
        this.tools = [];
        //
        this.drawTools = {};
        this.drawTools.point = new DrawPointTool({
            map: opt.map,
            cursor: 'crosshair',
        });
        this.drawTools.line = new DrawLineTool({
            map: opt.map,
            cursor: 'crosshair',
        });
        this.drawTools.polygon = new DrawPolygonTool({
            map: opt.map,
            cursor: 'crosshair',
        });
        //
        this.drawing = false;
        this.currentDrawTool = null;
        //
        this.handlers = {
            'click': this.onMouseClick.bind(this),
            'mouseup': this.onMouseUp.bind(this),
            'mousedown': this.onMouseDown.bind(this),
            'mousemove': this.onMouseMove.bind(this),
            'dblclick': this.onDblclick.bind(this),
        };
    },
    onClick: function(){
        for (let eventName in this.handlers) {
            this.map.on(eventName, this.handlers[eventName]);
        }
    },
    deactivate: function(){
        for (let eventName in this.handlers) {
            this.map.un(eventName, this.handlers[eventName]);
        }
    },
    add: function(tool){
        if (tool) {
            if (!this.toolCol.hasOwnProperty(tool.id)) {
                this.tools.push(tool);
                this.toolCol[tool.id] = tool;
            }
        }
    },
    remove: function(id) {
        if (this.toolCol.hasOwnProperty(id)) {
            for (let i=0;i<this.tools.length;i++) {
                if(this.tools[i].id === id) {
                    this.tools.splice(i,1);
                    break;
                }
            }
            delete this.toolCol[id];
        }
    },
    clear: function(){
        this.tools = [];
        this.toolCol = {};
    },
    startDraw: function(type, opts) {
        this.drawing = true;
        this.currentDrawTool = this.drawTools[type];
        this.currentDrawTool.onClick(opts);
    },
    endDraw: function() {
        this.drawing = false;
        if (this.currentDrawTool) {
            this.currentDrawTool.deactivate();
        }
        this.currentDrawTool = null;
    },
    onMouseUp: function (...args) {
        this._invoke('onMouseUp', args);
    },
    onMouseDown: function (...args) {
        this._invoke('onMouseDown', args);
    },
    onMouseMove: function (...args) {
        this._invoke('onMouseMove', args);
    },
    onMouseClick: function (...args) {
        this._invoke('onMouseClick', args);
    },
    onDblclick: function(...args) {
        this._invoke('onDblclick', args);
    },
    _invoke(fnName, ...args) {
        if (this.drawing && this.currentDrawTool) {
            this.currentDrawTool[fnName].apply(this.currentDrawTool,...args);
        } else {
            for (let i=0;i<this.tools.length;i++) {
                const tool = this.tools[i];
                try{
                    tool[fnName] && tool[fnName].apply(tool,...args);
                }catch(err) {
                    console.debug(err);
                }
            }
        }
    }
});
module.exports = Tool;